export default __webpack_public_path__ + "static/report-content-04-731be33beb9fc069b6818c47183ca254.png";